import { Box, Grid, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IAppReportEditItem } from "ui/Scripts/source/models/appReport/appReportEditItem";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { ModifyUserInfo } from "source/components/framework/User/ModifyUserInfo";
import { Translations } from "ui/Scripts/source/models/translations";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Base } from "ui/Scripts/source/framework/base";

interface IAppReportEditDialogReadOnlyPublishedViewProp {
    appReport: IAppReportEditItem;
    units: IIdTitleNode[];
}

const DialogSectionCardContent = styled(Box)(() => ({
    position: "relative",
    height: "calc(100vh - 300px)",
    overflow: "auto",
    paddingLeft: "0",
    paddingRight: "0",
}));

export const AppReportEditDialogReadOnlyPublishedView = (props: IAppReportEditDialogReadOnlyPublishedViewProp) => {
    const [unitTitle, setUnitTitle] = useState<string>("");
    const [interval, setInterval] = useState<string>("");

    useEffect(() => {
        const unit = IdTitleNode.getById(props.units, props.appReport.unitId);
        setUnitTitle(unit ? unit.title : "");
        const startDateStr = props.appReport.startDate
            ? Base.utcTimeToDateStr(props.appReport.startDate)
            : "";
        const endDateStr = props.appReport.endDate
            ? Base.utcTimeToDateStr(props.appReport.endDate)
            : "";
        setInterval(startDateStr && endDateStr
            ? `${startDateStr} - ${endDateStr}`
            : startDateStr || endDateStr);
    }, [props.appReport.unitId, props.units]);

    return (
        <Box>
            <GridRow>
                <Grid item sm={4}>
                    <DialogSectionCard
                        headerTitle={Translations.BasicInformation}
                    >
                        <DialogSectionCardContent>
                            <GridRow>
                                <Grid item sm={6}>
                                    <FormField title={Translations.Name} fullWidth margin={0}>
                                        {props.appReport.code}
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormField title={Translations.Unit} fullWidth margin={0}>
                                        {unitTitle}
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Interval} fullWidth>
                                        {interval}
                                    </FormField>
                                </Grid>
                            </GridRow>
                            {!!props.appReport.comment &&
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Description} fullWidth>
                                            {props.appReport.comment}
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            }
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.TaskCreated} fullWidth>
                                        <ModifyUserInfo
                                            modifyUser={props.appReport.createUser}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            {/* <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Modified} fullWidth>
                                        <ModifyUserInfo
                                            modifyUser={props.appReport.modifyUser}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow> */}
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Published} fullWidth>
                                        <ModifyUserInfo
                                            modifyUser={props.appReport.publishUser}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            {!!props.appReport.archiveUser &&
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Archived} fullWidth>
                                            <ModifyUserInfo
                                                modifyUser={props.appReport.archiveUser}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            }
                            {!!props.appReport.deleteUser &&
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Removed} fullWidth>
                                            <ModifyUserInfo
                                                modifyUser={props.appReport.deleteUser}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            }
                        </DialogSectionCardContent>
                    </DialogSectionCard>
                </Grid>
                <Grid item sm={8}>
                    <DialogSectionCard
                        headerTitle={Translations.Preview}
                    >
                        <DialogSectionCardContent>
                            <Box dangerouslySetInnerHTML={{ __html: props.appReport.reportData }} />
                        </DialogSectionCardContent>
                    </DialogSectionCard>
                </Grid>
            </GridRow>
        </Box>
    );
};